export default __webpack_public_path__ + "static/media/CNo.70-3.fe668002.jpg";